"use server";

import { cookies } from "next/headers";

// ==========================================
// توابع کمکی (مستقل شده برای جلوگیری از خطای ایمپورت)
// ==========================================
function normalizePhone(phone: string): string {
  if (!phone) return "";
  let p = phone.replace(/[\u0660-\u0669]/g, (c) => (c.charCodeAt(0) - 0x0660).toString());
  p = p.replace(/[\u06f0-\u06f9]/g, (c) => (c.charCodeAt(0) - 0x06f0).toString());
  p = p.replace(/\s+/g, "").trim();
  if (p.startsWith("+98")) p = "0" + p.slice(3);
  if (p.startsWith("0098")) p = "0" + p.slice(4);
  return p;
}

function isValidIranPhone(phone: string): boolean {
  return /^09\d{9}$/.test(phone);
}

// ==========================================
// پورت 8001 و مسیر اختصاصی admin
// ==========================================
const ADMIN_API_URL = "http://localhost:8001/api/v1/admin";

export async function sendAdminOtpAction(rawPhone: string) {
  const phone = normalizePhone(rawPhone);
  if (!isValidIranPhone(phone)) {
    return { success: false, error: "شماره موبایل معتبر نیست" };
  }

  try {
    const res = await fetch(`${ADMIN_API_URL}/auth/send-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mobile: phone }),
      cache: "no-store" 
    });
    
    const data = await res.json();
    
    if (!res.ok || !data.success) {
      return { success: false, error: data.message || data.error || data.detail || "شما مجوز ورود به این پنل را ندارید." };
    }
    
    return {
      success: true,
      devCode: data.devCode,
      message: data.message
    };
  } catch (err) {
    return { success: false, error: "خطای شبکه سرور داخلی. سرور ادمین در دسترس نیست." };
  }
}

export async function verifyAdminOtpAction(rawPhone: string, rawCode: string) {
  const phone = normalizePhone(rawPhone);
  const code = normalizePhone(rawCode);

  try {
    const res = await fetch(`${ADMIN_API_URL}/auth/verify-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mobile: phone, code }),
      cache: "no-store"
    });
    
    const data = await res.json();
    
    if (!res.ok || !data.success) {
      return { success: false, error: data.error || data.detail || "کد اشتباه است یا حساب قفل شده است." };
    }
    
    const cookieStore = await cookies();
    const isProd = process.env.NODE_ENV === "production";
    
    // 🔴 کوکی‌های اختصاصی ادمین
    if (data.token) {
      cookieStore.set("khooban_admin_access", data.token, {
        httpOnly: true,
        secure: isProd,
        sameSite: "lax",
        path: "/",
        maxAge: 30 * 24 * 60 * 60, // ۳۰ روز
      });
    }

    if (data.refresh_token) {
      cookieStore.set("khooban_admin_refresh", data.refresh_token, {
        httpOnly: true,
        secure: isProd,
        sameSite: "lax",
        path: "/",
        maxAge: 30 * 24 * 60 * 60,
      });
    }
    
    return {
      success: true,
      admin: data.admin,
    };
  } catch (err) {
    return { success: false, error: "خطای شبکه سرور داخلی." };
  }
}

export async function adminLogoutAction() {
  try {
    const cookieStore = await cookies();
    const token = cookieStore.get("khooban_admin_access")?.value;
    const refreshToken = cookieStore.get("khooban_admin_refresh")?.value;

    if (token && refreshToken) {
      await fetch(`${ADMIN_API_URL}/auth/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ refresh_token: refreshToken }),
        cache: "no-store"
      });
    }

    // 🔴 حذف کوکی‌های اختصاصی ادمین
    cookieStore.delete("khooban_admin_access");
    cookieStore.delete("khooban_admin_refresh");

    return { success: true };
  } catch (err) {
    return { success: false, error: "خطا در خروج از حساب" };
  }
}

export async function getAdminMeAction() {
  try {
    const cookieStore = await cookies();
    const token = cookieStore.get("khooban_admin_access")?.value;

    if (!token) return { success: false, error: "توکن ادمین یافت نشد" };

    const res = await fetch(`${ADMIN_API_URL}/auth/me`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      cache: "no-store"
    });

    const data = await res.json();
    if (!res.ok || !data.success) {
      return { success: false, error: data.error || "خطا در دریافت اطلاعات ادمین" };
    }

    return { success: true, data };
  } catch (err) {
    return { success: false, error: "خطای شبکه سرور داخلی." };
  }
}